import { StepBase } from './StepBase'
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { AuditLog } from '../Participant/AuditLog';

export class StepAudit extends StepBase
{
    async processStep(logic : LogicEngine) : Promise<boolean>
    {
        if (!this.raw.option_1)
        {
            console.log("SteAudit processStep missing option_1, should be the participant id");
            return false;
        }

        const participantId = logic.processTextReplacement(this.raw.option_1);
        const auditText = logic.processTextReplacement(this.text);

        /* Use the task manager to create the task and update the task count */
        const audit = new AuditLog(participantId, auditText);
        await audit.save();

        return true;
    }

}
